(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Stats-Neon"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    var animate = root.dataset.animate === 'true';
    var cards = root.querySelectorAll('.sn__card');

    // cursor-follow glow
    cards.forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var target = parseFloat(el.dataset.target);
      if (isNaN(target)) return;
      var decimals = parseInt(el.dataset.decimals || '0', 10);
      var prefix = el.dataset.prefix || '';
      var suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = prefix + target.toFixed(decimals) + suffix; return; }
      var dur = 1400, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) {
        c.classList.add('is-in');
        countUp(c.querySelector('.sn__value'));
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var i = Array.prototype.indexOf.call(cards, card);
        setTimeout(function () {
          if (animate) card.classList.add('is-in');
          countUp(card.querySelector('.sn__value'));
        }, animate ? i * 110 : 0);
        io.unobserve(card);
      });
    }, { threshold: 0.4 });

    cards.forEach(function (c) { io.observe(c); });
  }

  document.querySelectorAll('.sn').forEach(initSection);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.sn');
    if (root) initSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Trusted-brands"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    // reveal
    if (root.dataset.animate === 'true' && 'IntersectionObserver' in window) {
      var revs = root.querySelectorAll('.tb__intro,.tb__logo,.tb__review');
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Array.prototype.indexOf.call(revs, e.target);
          setTimeout(function () { e.target.classList.add('is-in'); }, i * 50);
          ro.unobserve(e.target);
        });
      }, { threshold: 0.15 });
      revs.forEach(function (el) { ro.observe(el); });
    }

    // pop + hover-float on logo tiles (lift, tilt toward cursor, settle back)
    root.querySelectorAll('[data-pop]').forEach(function (logo) {
      var inner = logo.querySelector('.tb__logo-inner');
      if (!inner) return;
      logo.addEventListener('pointermove', function (e) {
        var r = logo.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        inner.style.setProperty('--ry', (px * 16) + 'deg');
        inner.style.setProperty('--rx', (-py * 16) + 'deg');
      });
      logo.addEventListener('pointerleave', function () {
        inner.style.setProperty('--ry', '0deg');
        inner.style.setProperty('--rx', '0deg');
      });
    });

    // subtle 3D tilt on review cards
    root.querySelectorAll('[data-tilt]').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (px * 5) + 'deg) rotateX(' + (-py * 5) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  document.querySelectorAll('.tb').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.tb');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Why-Holofex"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.animate !== 'true' || !('IntersectionObserver' in window)) return;
    var items = root.querySelectorAll('.wh__item');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var i = Array.prototype.indexOf.call(items, entry.target);
        setTimeout(function () { entry.target.classList.add('is-in'); }, i * 80);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.3 });
    items.forEach(function (it) { io.observe(it); });
  }
  document.querySelectorAll('.wh').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.wh');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hfx-animation-header"] && !Shopify.designMode) return;
  try {
    
class HfxDimensionHero extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.logo=this.querySelector('[data-logo]');this.art=this.querySelector('[data-art]');this.front=this.querySelector('[data-face]');this.cloud=this.querySelector('[data-particles]');this.button=this.querySelector('[data-pause]');if(!this.logo||!this.front)return;this.layers=[];for(let i=24;i>=1;i--){const el=document.createElement('div');el.className='hfx-motion-scene__depth';el.style.setProperty('--hfx-logo','url("'+this.front.currentSrc.replace(/"/g,'%22')+'")');this.logo.insertBefore(el,this.logo.firstChild);this.layers.push({el,z:-i*1.15})}this.front.addEventListener('load',()=>this.layers.forEach(l=>l.el.style.setProperty('--hfx-logo','url("'+this.front.currentSrc.replace(/"/g,'%22')+'")')));this.particles=[];const colors=['#7b34ed','#216af5','#ed873b'];for(let i=0;i<45;i++){const el=document.createElement('i');el.className=i%9===0?'hfx-motion-scene__streak':'hfx-motion-scene__particle';el.style.setProperty('--c',colors[i%3]);this.cloud.appendChild(el);this.particles.push({el,phase:i*2.39996323,r:360+(i%7)*14,ry:125+(i%5)*12,size:1.4+(i%4)*.65})}this.motionQuery=matchMedia('(prefers-reduced-motion:reduce)');this.manualPaused=this.motionQuery.matches;this.elapsed=this.manualPaused?4800:0;this.last=null;this.visible=true;this.visibilityHandler=()=>{this.last=null;if(!document.hidden)this.start()};document.addEventListener('visibilitychange',this.visibilityHandler);this.motionHandler=e=>{this.manualPaused=e.matches;this.elapsed=e.matches?4800:0;this.last=null;this.updateButton();this.draw(this.elapsed/1000);this.start()};this.motionQuery.addEventListener('change',this.motionHandler);this.button?.addEventListener('click',()=>{this.manualPaused=!this.manualPaused;this.last=null;this.updateButton();this.start()});this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.last=null;this.start()});this.observer.observe(this);this.resize=new ResizeObserver(()=>this.draw(this.elapsed/1000));this.resize.observe(this.art);this.draw(this.elapsed/1000);this.updateButton();this.start()}
 updateButton(){if(!this.button)return;this.button.textContent=this.manualPaused?'▶':'Ⅱ';this.button.setAttribute('aria-label',this.manualPaused?this.dataset.playLabel:this.dataset.pauseLabel);this.button.setAttribute('aria-pressed',String(this.manualPaused))}
 start(){cancelAnimationFrame(this.frame);if(this.manualPaused||!this.visible||document.hidden)return;this.frame=requestAnimationFrame(now=>this.tick(now))}
 tick(now){if(this.manualPaused||!this.visible||document.hidden)return;if(this.last!==null)this.elapsed=(this.elapsed+Math.min(now-this.last,80))%8000;this.last=now;this.draw(this.elapsed/1000);this.frame=requestAnimationFrame(n=>this.tick(n))}
 draw(t){const clamp=x=>Math.max(0,Math.min(1,x)),ease=x=>.5-Math.cos(Math.PI*clamp(x))/2,mix=(a,b,k)=>a+(b-a)*k,s=this.art.clientWidth/1200;let x=0,y=0,z=0,scale=.9,depth=ease((t-.25)/1.45),amount=ease((t-.5));if(t<2.3){const k=ease((t-.35)/1.9);x=14*k;y=-22*k;z=-5*k;scale=mix(.9,1.05,k)}else if(t<5.9){const k=ease((t-2.3)/2.5);x=mix(14,7,k);y=mix(-22,15,k);z=mix(-5,2,k);scale=mix(1.05,1.01,k)}else{const k=ease((t-5.9)/1.7);x=mix(7,0,k);y=mix(15,0,k);z=mix(2,0,k);scale=mix(1.01,.9,k)}if(t>=6.15){const k=1-ease((t-6.15)/1.45);depth=k;amount=k}this.logo.style.transform='rotateX('+x+'deg) rotateY('+y+'deg) rotateZ('+z+'deg) scale('+scale+')';for(const l of this.layers)l.el.style.transform='translateZ('+(l.z*depth*s)+'px)';const phase=t<5.1?Math.PI*1.1*ease((t-.5)/4.6):mix(Math.PI*1.1,Math.PI*2,ease((t-5.1)/2.9));for(const [i,p]of this.particles.entries()){const a=p.phase+phase,zz=Math.sin(a),px=Math.cos(a)*p.r*s,py=(Math.sin(a)*p.ry+Math.cos(a*2+i)*14)*s;p.el.style.transform='translate('+px+'px,'+py+'px) scale('+(p.size*(.7+(zz+1)*.19)*s)+')';p.el.style.opacity=amount*(.25+(zz+1)*.28);p.el.style.zIndex=zz>0?'4':'0'}}
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.resize?.disconnect();document.removeEventListener('visibilitychange',this.visibilityHandler);this.motionQuery?.removeEventListener('change',this.motionHandler);this.ready=false}
}
if(!customElements.get('hfx-dimension-hero'))customElements.define('hfx-dimension-hero',HfxDimensionHero);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hfx-product-spotlight"] && !Shopify.designMode) return;
  try {
    

class HfxProductSpotlight extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.classList.add('is-js');
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.medias = Array.from(this.querySelectorAll('[data-hfx-media]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-hfx-thumb]'));
    this.soundBtn = this.querySelector('[data-hfx-sound]');
    this.current = 0;
    this.inView = false;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.medias.forEach(media => {
      const iframe = media.querySelector('iframe');
      if (iframe && !iframe.dataset.hfxSrc) iframe.dataset.hfxSrc = iframe.getAttribute('src');
      const video = media.querySelector('video');
      if (video && this.reduced.matches) video.controls = true;
    });
    this.thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      this.show(Number(thumb.dataset.hfxThumb));
    }, options));
    if (this.soundBtn) this.soundBtn.addEventListener('click', () => {
      const video = this.video();
      if (!video) return;
      video.muted = !video.muted;
      this.updateSound();
      if (video.paused) this.play(video);
    }, options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.addEventListener('shopify:block:select', event => {
      const index = this.medias.indexOf(event.target.closest('[data-hfx-media]'));
      if (index >= 0) this.show(index);
    }, options);
    this.show(0);
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.classList.add('is-inview');
        this.sync();
      }, { threshold: .15 });
      this.observer.observe(this);
    } else {
      this.inView = true;
      this.classList.add('is-inview');
      this.sync();
    }
  }
  video() {
    return this.medias[this.current]?.querySelector('video') || null;
  }
  play(video) {
    const result = video.play();
    if (result?.catch) result.catch(() => { video.controls = true; });
  }
  updateSound() {
    if (!this.soundBtn) return;
    const video = this.video();
    this.soundBtn.hidden = !video;
    this.soundBtn.classList.toggle('is-on', Boolean(video && !video.muted));
    this.soundBtn.setAttribute('aria-label', video && !video.muted ? 'Mute video' : 'Unmute video');
    this.soundBtn.setAttribute('aria-pressed', String(Boolean(video && !video.muted)));
  }
  show(index) {
    if (!Number.isInteger(index) || index < 0 || index >= this.medias.length) {
      this.updateSound();
      return;
    }
    this.current = index;
    this.medias.forEach((media, i) => {
      const active = i === index;
      media.classList.toggle('is-on', active);
      media.inert = !active;
      const video = media.querySelector('video');
      if (video && active) video.muted = true;
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-current', String(i === index));
    });
    this.sync();
    this.updateSound();
  }
  sync() {
    const visible = this.inView && !document.hidden;
    this.medias.forEach((media, i) => {
      const active = i === this.current && visible;
      const video = media.querySelector('video');
      if (video) {
        if (active && !this.reduced.matches) this.play(video);
        else video.pause();
      }
      const iframe = media.querySelector('iframe');
      if (iframe?.dataset.hfxSrc) {
        const source = active ? iframe.dataset.hfxSrc : 'about:blank';
        if (iframe.getAttribute('src') !== source) iframe.setAttribute('src', source);
      }
    });
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.abort?.abort();
    this.medias?.forEach(media => {
      media.querySelector('video')?.pause();
      const iframe = media.querySelector('iframe');
      if (iframe) iframe.setAttribute('src', 'about:blank');
    });
    this.initialized = false;
  }
}
if (!customElements.get('hfx-product-spotlight')) {
  customElements.define('hfx-product-spotlight', HfxProductSpotlight);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hfx-setup-preview"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hfx-setup-preview'))customElements.define('hfx-setup-preview',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();this.requests=new AbortController();this.pollTimer=null;this.busy=false;this.serverReady=false;this.remaining=0;this.photo=null;
  this.q=s=>this.querySelector(s);const on=(el,ev,fn)=>el.addEventListener(ev,fn,{signal:this.events.signal});
  on(this.q('form'),'submit',e=>{e.preventDefault();this.submit()});on(this.q('[data-retry]'),'click',()=>{if(!this.busy)this.allowance()});
  on(this.q('[data-photo]'),'change',e=>this.load(e.target.files[0]));
  on(this.q('[data-logo]'),'change',e=>this.loadLogo(e.target.files[0]));
  ['[data-x]','[data-y]','[data-size]'].forEach(s=>on(this.q(s),'input',()=>this.marker()));
  on(this.q('[data-consent]'),'change',()=>this.update());on(this.q('[data-device]'),'change',()=>this.update());
  this.workerBase=this.dataset.workerUrl||'';this.token=this.workerBase?sessionStorage.getItem('hfx-preview:'+this.workerBase)||'':'';if(this.workerBase){this.q('.hfx-tool__signin')?.remove();this.q('[data-quota]').textContent='Two previews per browser session. Network limits also apply.';}this.marker();this.demo=this.dataset.demoMode==='true';if(this.demo){this.q('.hfx-tool__signin')?.remove();this.q('[data-consent]').closest('label').hidden=true;this.q('[data-consent]').required=false;this.q('[data-logo]').required=false;this.q('[data-quota]').textContent='Demo only: shows a pre-generated BUSHFIRE trade-show example. Uploaded images and choices do not change this sample.';this.q('[data-auth]').hidden=true;this.say('No sign-in needed. Click Show sample preview to view the AI-generated example.');this.update()}else this.allowance();
 }
 say(t){this.q('[role=status]').textContent=t}
 endpoint(){if(this.workerBase){const w=new URL(this.workerBase);if(w.protocol!=='https:'||w.hostname!=='holofex-preview.muddy-butterfly-f2cf.workers.dev')throw Error('Invalid Worker address.');return w.origin+'/apps/holofex-preview'}const raw=this.dataset.endpoint||'';if(!raw.startsWith('/apps/')||raw.startsWith('//')||/[?#]/.test(raw))throw Error('Setup previews are not connected yet. Please contact our team.');const u=new URL(raw,location.origin);if(u.origin!==location.origin)throw Error('Invalid preview service.');return u.href.replace(/\/$/,'')}
 async api(path,options={}){const res=await fetch(this.endpoint()+path,{...options,credentials:this.workerBase?'omit':'same-origin',signal:this.requests.signal,headers:{Accept:'application/json',...(this.token?{Authorization:'Bearer '+this.token}:{}),...(options.headers||{})}});const data=await res.json().catch(()=>({}));if(!res.ok){const messages={401:'Please sign in to generate a setup preview.',403:'Your request could not be verified. Refresh this page.',409:'A preview is already running. Check your allowance shortly.',413:'The image is too large.',422:'This photo could not be used. Try a clear photo of your space.',429:'Your preview allowance or today’s service limit has been reached.',503:'The preview service is temporarily unavailable.'};throw Error(messages[res.status]||'The preview service could not complete this request.')}return data}
 async verifyWidget(key){const box=this.q('[data-verification]');box.hidden=false;if(this.widget!=null)return;if(!window.turnstile){await new Promise((resolve,reject)=>{let script=document.querySelector('script[data-hfx-turnstile]');if(!script){script=document.createElement('script');script.dataset.hfxTurnstile='true';script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;document.head.append(script)}if(window.turnstile)return resolve();script.addEventListener('load',resolve,{once:true});script.addEventListener('error',reject,{once:true})})}if(!this.isConnected)return;this.widget=window.turnstile.render(box,{sitekey:key,action:'holofex-preview','error-callback':()=>{this.say('Verification could not load in this browser. Open this Shopify preview in Chrome, then try again.');return true},callback:async token=>{try{const d=await this.api('/session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({turnstileToken:token})});this.token=d.token;sessionStorage.setItem('hfx-preview:'+this.workerBase,d.token);box.hidden=true;await this.allowance()}catch{this.say('Verification could not complete. Please retry.');window.turnstile.reset(this.widget)}}})}
 async uploadImage(file,isLogo=false){if(!this.workerBase)return file;const bitmap=await createImageBitmap(file);const canvas=document.createElement('canvas');let scale=Math.min(1,1024/Math.max(bitmap.width,bitmap.height));let blob;for(let i=0;i<4;i++){const w=Math.max(1,Math.round(bitmap.width*scale)),h=Math.max(1,Math.round(bitmap.height*scale));canvas.width=Math.max(256,w);canvas.height=Math.max(256,h);const ctx=canvas.getContext('2d');if(!isLogo){ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);}ctx.drawImage(bitmap,(canvas.width-w)/2,(canvas.height-h)/2,w,h);blob=await new Promise(r=>canvas.toBlob(r,!isLogo&&file.type==='image/jpeg'?'image/jpeg':'image/png',.85));if(blob&&blob.size<=1024*1024)break;scale*=.7}bitmap.close();if(!blob||blob.size>1024*1024)throw Error('Please use a simpler or smaller image.');return new File([blob],!isLogo&&file.type==='image/jpeg'?'preview.jpg':'preview.png',{type:blob.type})}
 async allowance(){this.serverReady=false;this.update();try{const d=await this.api('/status');if(this.workerBase&&!d.authenticated){if(d.ready&&d.turnstileSiteKey){this.verifyWidget(d.turnstileSiteKey);this.say('Complete the verification below to unlock two previews.')}else this.say('Cloudflare is connected. Live generation is waiting for its private service configuration.');this.update();return}this.remaining=Math.max(0,Math.min(2,Number(d.remaining)||0));this.serverReady=d.authenticated===true&&d.ready!==false;this.renderMode=d.mode||'';if(this.renderMode==='local-composite'){this.q('[data-quota]').textContent='Local test only: places your uploaded logo on the sample scene; scene choices do not trigger AI generation.';this.q('[data-consent]').closest('label').hidden=true;this.q('[data-consent]').required=false;this.q('[data-consent]').checked=true;}this.q('[data-auth]').textContent=this.serverReady?(this.workerBase?'Verified. Your allowance is checked securely.':'Signed in. Your allowance is checked securely.'):'Sign in to generate your setup preview.';this.q('[data-quota]').textContent=this.remaining+' of 2 previews remaining.';if(d.activeJobId){this.busy=true;this.say('Resuming your existing preview…');this.poll(d.activeJobId,Date.now())}else this.say(this.remaining?'Upload your logo and choose your device and setting.':'No previews available. Contact our team for help.')}catch(e){if(e.name!=='AbortError')this.say(e.message)}this.update()}
 update(){if(this.demo){this.q('[data-generate]').disabled=false;this.q('[data-generate]').textContent='Show sample preview';this.q('[data-retry]').hidden=true;return}this.q('[data-generate]').disabled=this.busy||!this.serverReady||!this.remaining||!this.logo||!this.q('[data-device]').value||!this.q('[data-consent]').checked;this.q('[data-generate]').textContent=this.busy?'Creating preview…':this.renderMode==='local-composite'?'Create local test preview':'Generate my preview';this.q('[data-retry]').disabled=this.busy;this.q('[data-retry]').hidden=this.serverReady||this.busy;this.querySelectorAll('input,select').forEach(el=>el.disabled=this.busy)}
 async load(file){this.loadToken=null;this.photo=null;this.q('[data-result-wrap]').hidden=true;this.q('[data-room]').hidden=true;this.q('[data-placeholder]').hidden=false;if(this.url)URL.revokeObjectURL(this.url);this.url=null;this.update();if(!file)return;if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>10*1024*1024){this.say('Choose a JPEG, PNG or WebP smaller than 10 MB.');return}
  const token=Symbol();this.loadToken=token;const url=URL.createObjectURL(file);this.url=url;const image=new Image();image.onload=()=>{if(this.loadToken!==token)return;if(image.naturalWidth*image.naturalHeight>25000000||Math.min(image.naturalWidth,image.naturalHeight)<256){URL.revokeObjectURL(url);this.url=null;this.say('Choose a photo at least 256 pixels per side and no larger than 25 megapixels.');return}this.photo=file;this.imageSize={w:image.naturalWidth,h:image.naturalHeight};const room=this.q('[data-room]');room.src=url;room.hidden=false;this.q('[data-placeholder]').hidden=true;this.q('.hfx-setup__stage').style.aspectRatio=image.naturalWidth+'/'+image.naturalHeight;this.marker();this.update();this.say('Position the outline where your device should go.')};image.onerror=()=>{if(this.loadToken!==token)return;URL.revokeObjectURL(url);this.url=null;this.say('This photo could not be read.')};image.src=url;
 }
 loadLogo(file){this.logoToken=Symbol();const token=this.logoToken;this.logo=null;if(this.logoUrl)URL.revokeObjectURL(this.logoUrl);this.logoUrl=null;this.q('[data-logo-preview]').hidden=true;this.update();if(!file)return;if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>5*1024*1024){this.say('Choose a PNG, JPEG or WebP logo up to 5 MB.');return}const url=URL.createObjectURL(file);this.logoUrl=url;const image=new Image();image.onload=()=>{if(this.logoToken!==token)return;if(image.naturalWidth*image.naturalHeight>16000000||Math.min(image.naturalWidth,image.naturalHeight)<32){this.say('Choose a logo at least 32 pixels per side and at most 16 megapixels.');return}this.logo=file;this.q('[data-logo-preview]').src=url;this.q('[data-logo-preview]').hidden=false;this.say('Logo ready. Choose HoloPack or standalone, then your event setting.');this.update()};image.onerror=()=>{if(this.logoToken===token)this.say('This logo could not be read. Try a PNG.')};image.src=url}
 placement(){const size=Number(this.q('[data-size]').value)/100;const aspect=this.imageSize?this.imageSize.w/this.imageSize.h:4/3;const w=Math.min(.9,size*.6/aspect);return{x:Math.max(w/2,Math.min(1-w/2,Number(this.q('[data-x]').value)/100)),y:Math.max(size/2,Math.min(1-size/2,Number(this.q('[data-y]').value)/100)),width:w,height:size}}
 marker(){const p=this.placement();Object.assign(this.q('[data-marker]').style,{left:(p.x-p.width/2)*100+'%',top:(p.y-p.height/2)*100+'%',width:p.width*100+'%',height:p.height*100+'%'})}
 async submit(){if(this.demo){const url=this.dataset.sampleUrl;this.q('[data-result]').src=url;this.q('[data-download]').href=url;this.q('[data-result-wrap]').hidden=false;this.q('[data-result-wrap] h3').textContent='BUSHFIRE · AI-generated sample';this.q('.hfx-setup__stage').hidden=true;this.say('Sample generated with our image tool. This demo does not send your uploads to an AI service.');return}if(this.q('[data-generate]').disabled)return;this.busy=true;this.update();this.say('Submitting your photo securely…');try{const f=new FormData();if(this.photo)f.append('photo',await this.uploadImage(this.photo));f.append('logo',await this.uploadImage(this.logo,true));f.append('deviceId',this.q('[data-device]').value);f.append('environment',this.q('[data-environment]').value);f.append('placement',JSON.stringify(this.placement()));f.append('consent','true');const d=await this.api('/jobs',{method:'POST',headers:{'Idempotency-Key':crypto.randomUUID()},body:f});if(typeof d.jobId!=='string')throw Error('The service returned an invalid job.');this.poll(d.jobId,Date.now())}catch(e){this.busy=false;this.update();if(e.name!=='AbortError')this.say(e.message)}}
 async poll(id,start){if(!this.isConnected)return;try{const d=await this.api('/jobs/'+encodeURIComponent(id));if(d.status==='succeeded'){const u=new URL(d.imageUrl);if(u.protocol!=='https:'&&!(u.origin===location.origin&&['127.0.0.1','localhost'].includes(location.hostname)))throw Error('The service returned an invalid preview URL.');this.q('[data-result-wrap] h3').textContent=d.mode==='local-composite'?'Your logo · local composite (not AI)':'Your AI setup preview';this.q('[data-result]').src=u.href;this.q('[data-download]').href=u.href;this.q('[data-result-wrap]').hidden=false;this.q('.hfx-setup__stage').hidden=true;this.q('[data-result]').alt=d.mode==='local-composite'?'Your logo composited onto a sample display':'AI-generated concept of your Holofex setup';this.busy=false;await this.allowance();this.say(d.mode==='local-composite'?'Your uploaded logo has been rendered locally. No Runware generation or charge.':'Your setup preview is ready. Compare it with your original photo above.');return}if(d.status==='failed'){this.busy=false;await this.allowance();this.say('Generation failed. Your allowance has not been used. Try another photo.');return}if(Date.now()-start>180000){this.busy=false;this.serverReady=false;this.update();this.say('Your preview is taking longer. Click Check allowance to resume the same job without creating another.');return}this.say('Creating your setup preview…');this.pollTimer=setTimeout(()=>this.poll(id,start),2500)}catch(e){this.busy=false;this.serverReady=false;this.update();if(e.name!=='AbortError')this.say(e.message+' Click Check allowance to recover an existing preview.')}}
 disconnectedCallback(){this.events.abort();this.requests.abort();if(this.widget!=null&&window.turnstile)window.turnstile.remove(this.widget);clearTimeout(this.pollTimer);this.loadToken=null;this.logoToken=null;if(this.logoUrl)URL.revokeObjectURL(this.logoUrl);if(this.url)URL.revokeObjectURL(this.url);this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hfx-video-preview"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hfx-video-preview'))customElements.define('hfx-video-preview',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();const signal=this.events.signal;
  this.video=this.querySelector('video');this.canvas=this.querySelector('canvas');this.status=this.querySelector('[role=status]');this.play=this.querySelector('[data-play]');
  const q=s=>this.querySelector(s);const listen=(el,event,fn)=>el.addEventListener(event,fn,{signal});
  listen(q('[data-file]'),'change',e=>this.load(e.target.files[0]));
  listen(this.play,'click',()=>{if(this.video.paused)this.video.play().catch(()=>this.say('Tap Play again to start playback.'));else this.video.pause()});
  listen(q('[data-clear]'),'click',()=>this.clear());
  listen(q('[data-demo]'),'click',()=>this.loadDemo());
  this.querySelectorAll('input[type=range]').forEach(el=>listen(el,'input',()=>{q('.hfx-fan-scene').style.setProperty('--scene-dim',q('[data-dim]').value/100);this.draw()}));
  listen(this.video,'play',()=>{this.play.textContent='Pause';this.say(this.demo?'Playing BUSHFIRE demo.':'Playing your video.');this.tick()});listen(this.video,'pause',()=>{this.play.textContent='Play';cancelAnimationFrame(this.frame)});
  listen(this.video,'loadedmetadata',()=>{
   const v=this.video;if(!Number.isFinite(v.duration)||v.duration>180||!v.videoWidth||Math.max(v.videoWidth,v.videoHeight)>4096){this.clear();this.say('Choose an MP4 up to 3 minutes and 4096 pixels per side.');return}
   this.valid=true;this.play.disabled=false;this.video.currentTime=Math.min(.1,this.video.duration/2);this.say(this.demo?'BUSHFIRE demo ready. Press Play to preview.':'Ready. Press Play to preview your content.');
  });
  listen(this.video,'seeked',()=>this.draw());
  listen(this.video,'loadeddata',()=>{if(this.valid){q('.hfx-fan__empty').hidden=true;this.draw();if(this.demo&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.video.play().catch(()=>this.say('BUSHFIRE demo loaded. Tap Play to start.'))}});
  listen(this.video,'error',()=>{this.clear();this.say('This MP4 could not be decoded. Try an H.264 MP4.');});
  this.io=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.video.pause()});this.io.observe(this);
  listen(document,'visibilitychange',()=>{if(document.hidden)this.video.pause()});
  this.loadDemo();
 }
 say(t){this.status.textContent=t}
 setup(){
  if(this.gl)return;const gl=this.canvas.getContext('webgl',{alpha:true,premultipliedAlpha:false});if(!gl)throw Error('WebGL is unavailable. Try another browser or enable hardware acceleration.');this.gl=gl;
  this.canvas.width=768;this.canvas.height=768;
  const shader=(type,src)=>{const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('Video preview shader is unavailable.');return s};
  this.program=gl.createProgram();gl.attachShader(this.program,shader(gl.VERTEX_SHADER,'attribute vec2 p;varying vec2 uv;void main(){uv=(p+1.0)*0.5;gl_Position=vec4(p,0.,1.);}'));
  gl.attachShader(this.program,shader(gl.FRAGMENT_SHADER,'precision mediump float;uniform sampler2D video;uniform float threshold;uniform float softness;uniform float zoom;uniform vec2 offset;uniform vec2 fit;varying vec2 uv;void main(){vec2 t=(uv-0.5)/(zoom*fit)+0.5-offset;if(any(lessThan(t,vec2(0.)))||any(greaterThan(t,vec2(1.)))){gl_FragColor=vec4(0.);return;}vec4 c=texture2D(video,t);float level=max(c.r,max(c.g,c.b));float a=smoothstep(threshold,threshold+softness,level);gl_FragColor=vec4(c.rgb,a);}'));
  gl.linkProgram(this.program);if(!gl.getProgramParameter(this.program,gl.LINK_STATUS))throw Error('Could not initialize video preview.');gl.useProgram(this.program);
  this.buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);const p=gl.getAttribLocation(this.program,'p');gl.enableVertexAttribArray(p);gl.vertexAttribPointer(p,2,gl.FLOAT,false,0,0);
  this.texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 }
 loadDemo(){this.clear();if(!this.dataset.demoUrl)return;try{this.setup();this.demo=true;this.video.crossOrigin='anonymous';this.video.src=this.dataset.demoUrl;this.video.load();this.say('Loading BUSHFIRE demo…')}catch(e){this.say(e.message)}}
 load(file){this.clear();if(!file)return;if(file.size>250*1024*1024){this.say('Your file is '+Math.ceil(file.size/1024/1024)+' MB. Choose an MP4 up to 250 MB.');return}if(!(/\.mp4$/i.test(file.name))){this.say('Choose an .mp4 video file.');return}try{this.setup();this.url=URL.createObjectURL(file);this.video.src=this.url;this.video.load();this.say('Checking video…')}catch(e){this.say(e.message)}}
 draw(){if(!this.valid||this.video.readyState<2||!this.gl)return;try{const gl=this.gl;const val=s=>Number(this.querySelector(s).value);gl.useProgram(this.program);gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,this.video);const aspect=this.video.videoWidth/this.video.videoHeight;gl.uniform2f(gl.getUniformLocation(this.program,'fit'),Math.min(1,aspect),Math.min(1,1/aspect));gl.uniform1f(gl.getUniformLocation(this.program,'threshold'),val('[data-threshold]')/100);gl.uniform1f(gl.getUniformLocation(this.program,'softness'),val('[data-softness]')/100);gl.uniform1f(gl.getUniformLocation(this.program,'zoom'),val('[data-zoom]')/100);gl.uniform2f(gl.getUniformLocation(this.program,'offset'),val('[data-x]')/100,-val('[data-y]')/100);gl.viewport(0,0,768,768);gl.drawArrays(gl.TRIANGLES,0,6)}catch(e){this.video.pause();this.say('Unable to render this video. Try an H.264 MP4.')}}
 tick(){cancelAnimationFrame(this.frame);if(this.video.paused||!this.isConnected)return;this.draw();this.frame=requestAnimationFrame(()=>this.tick())}
 clear(){this.demo=false;this.valid=false;cancelAnimationFrame(this.frame);this.video.pause();this.video.removeAttribute('src');this.video.load();if(this.url)URL.revokeObjectURL(this.url);this.url=null;this.querySelector('[data-file]').value='';this.play.disabled=true;this.querySelector('.hfx-fan__empty').hidden=false;if(this.gl){this.gl.clearColor(0,0,0,0);this.gl.clear(this.gl.COLOR_BUFFER_BIT)}this.say('Choose a square MP4 to start.')}
 disconnectedCallback(){this.events.abort();this.io.disconnect();this.clear();if(this.gl){this.gl.deleteTexture(this.texture);this.gl.deleteBuffer(this.buffer);this.gl.deleteProgram(this.program)}this.gl=null;this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holofex-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hf-display-compare')) {
  customElements.define('hf-display-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const templates = [...this.querySelectorAll('template[data-product]')];
      const selects = [...this.querySelectorAll('[data-select]')];
      const update = select => {
        const template = templates.find(t => t.dataset.product === select.value);
        const slot = select.closest('.hfc-column').querySelector('[data-slot]');
        if (template) slot.replaceChildren(template.content.cloneNode(true));
        this.alignRows();
      };
      selects.forEach((select, index) => {
        select.selectedIndex = Math.min(index, select.options.length - 1);
        select.closest('label').hidden = false;
        select.addEventListener('change', () => update(select));
        update(select);
      });
      this.observer = new ResizeObserver(() => this.alignRows());
      this.observer.observe(this);
    }
    alignRows() {
      const columns = [...this.querySelectorAll('[data-slot]')];
      const groups = ['h4', '.hfc-variant', ...Array.from({length:6}, (_, i) => `dl > div:nth-child(${i + 1})`)];
      for (const selector of groups) {
        const rows = columns.map(c => c.querySelector(selector)).filter(Boolean);
        rows.forEach(r => r.style.minHeight = '');
        const height = Math.max(0, ...rows.map(r => r.getBoundingClientRect().height));
        rows.forEach(r => r.style.minHeight = `${height}px`);
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holofex-wall-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('holofex-wall-configurator')) {
    customElements.define('holofex-wall-configurator', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.form = this.querySelector('[data-configurator-form]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.status = this.querySelector('[data-status]');
        this.preview = this.querySelector('[data-preview]');
        this.previewGrid = this.querySelector('[data-preview-grid]');
        this.models = [...this.querySelectorAll('[data-model]')];
        this.configurations = [...this.querySelectorAll('[data-configuration]')];
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency
        });
        this.preview.style.viewTransitionName = `holofex-preview-${this.dataset.sectionId}`;
        this.form?.addEventListener('change', () => this.update(true));
        this.form?.addEventListener('submit', (event) => this.addToCart(event));
        this.update(false);
      }

      getSelection() {
        const modelInput = this.querySelector('input[name^="holofex-size-"]:checked');
        const configurationInput = this.querySelector('input[name^="holofex-configuration-"]:checked');
        const model = modelInput?.closest('[data-model]');
        const configuration = configurationInput?.closest('[data-configuration]');
        if (!model || !configuration) return null;
        const diameter = Number(model.dataset.diameter);
        const spacing = Number(model.dataset.spacing);
        const columns = Number(configuration.dataset.columns);
        const rows = Number(configuration.dataset.rows);
        const quantity = columns * rows;
        return {
          model,
          configuration,
          modelName: model.dataset.modelName,
          size: Number(model.dataset.model),
          diameter,
          spacing,
          overlap: diameter - spacing,
          clearance: Number(model.dataset.clearance),
          columns,
          rows,
          quantity,
          width: diameter + ((columns - 1) * spacing),
          height: diameter + ((rows - 1) * spacing),
          variantId: model.dataset.variantId,
          price: Number(model.dataset.price),
          available: model.dataset.available === 'true',
          inventory: Number(model.dataset.inventory),
          inventoryManaged: model.dataset.inventoryManaged === 'true',
          inventoryPolicy: model.dataset.inventoryPolicy,
          label: configuration.dataset.label
        };
      }

      update(animate) {
        const selection = this.getSelection();
        if (!selection) {
          this.addButton.disabled = true;
          this.addLabel.textContent = this.dataset.unconfiguredLabel;
          return;
        }
        const render = () => {
          this.drawPreview(selection);
          this.updateSummary(selection);
        };
        const canTransition = animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (canTransition) document.startViewTransition(render);
        else render();
      }

      drawPreview(selection) {
        this.previewGrid.replaceChildren();
        const availableWidth = this.preview.clientWidth;
        const availableHeight = this.preview.clientHeight;
        const scale = Math.min(availableWidth / selection.width, availableHeight / selection.height) * .9;
        const deviceSize = selection.diameter * scale;
        const gridWidth = selection.width * scale;
        const gridHeight = selection.height * scale;
        const originX = (availableWidth - gridWidth) / 2;
        const originY = (availableHeight - gridHeight) / 2;

        for (let row = 0; row < selection.rows; row += 1) {
          for (let column = 0; column < selection.columns; column += 1) {
            const device = document.createElement('span');
            const hub = document.createElement('i');
            const positionLabel = document.createElement('b');
            const mountLabel = document.createElement('b');
            const isTop = (row + column) % 2 === 0;
            device.className = `holofex-wall__device holofex-wall__device--${isTop ? 'top' : 'bottom'}`;
            hub.className = 'holofex-wall__hub';
            positionLabel.className = 'holofex-wall__position-label';
            positionLabel.textContent = `${row + 1}-${column + 1}`;
            mountLabel.className = 'holofex-wall__mount-label';
            mountLabel.textContent = isTop ? this.dataset.topLabel : this.dataset.bottomLabel;
            device.style.width = `${deviceSize}px`;
            device.style.left = `${originX + (column * selection.spacing * scale)}px`;
            device.style.top = `${originY + (row * selection.spacing * scale)}px`;
            device.style.zIndex = isTop ? '2' : '1';
            device.append(hub, positionLabel, mountLabel);
            this.previewGrid.append(device);
          }
        }

        const widthCm = this.formatCentimetres(selection.width);
        const heightCm = this.formatCentimetres(selection.height);
        this.preview.setAttribute('aria-label', this.template(this.dataset.previewTemplate, {
          model: selection.modelName,
          configuration: `${selection.columns} × ${selection.rows}`,
          quantity: selection.quantity,
          width: widthCm,
          height: heightCm
        }));
        this.setText('[data-preview-width]', `${widthCm} cm`);
        this.setText('[data-preview-height]', `${heightCm} cm`);
        this.setText('[data-preview-model]', selection.modelName);
        this.setText('[data-preview-layout]', `${selection.columns} × ${selection.rows}`);
        this.setText('[data-preview-units]', selection.quantity);
      }

      updateSummary(selection) {
        const widthCm = this.formatCentimetres(selection.width);
        const heightCm = this.formatCentimetres(selection.height);
        const total = this.moneyFormatter.format((selection.price * selection.quantity) / 100);
        this.setText('[data-summary-quantity]', selection.quantity);
        this.setText('[data-summary-footprint]', `${widthCm} × ${heightCm} cm`);
        this.setText('[data-summary-spacing]', `${selection.spacing} mm`);
        this.setText('[data-summary-overlap]', `${selection.overlap} mm`);
        this.setText('[data-summary-clearance]', `${selection.clearance} mm`);
        this.setText('[data-summary-configuration]', selection.label);
        this.setText('[data-summary-total]', selection.variantId ? total : '—');
        this.status.textContent = '';
        this.status.dataset.error = 'false';

        let disabled = false;
        let label = this.template(this.dataset.addTemplate, {
          quantity: selection.quantity,
          size: selection.size,
          total
        });
        if (!selection.variantId) {
          disabled = true;
          label = this.dataset.unconfiguredLabel;
        } else if (!selection.available) {
          disabled = true;
          label = this.dataset.unavailableLabel;
        } else if (selection.inventoryManaged && selection.inventoryPolicy !== 'continue' && selection.inventory < selection.quantity) {
          disabled = true;
          label = this.template(this.dataset.insufficientTemplate, { available: Math.max(0, selection.inventory) });
        }
        this.addButton.disabled = disabled;
        this.addLabel.textContent = label;
      }

      async addToCart(event) {
        event.preventDefault();
        const selection = this.getSelection();
        if (!selection || this.addButton.disabled) return;
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.addLabel.textContent = this.dataset.addingLabel;
        this.status.textContent = '';
        this.status.dataset.error = 'false';
        const footprint = `${this.formatCentimetres(selection.width)} × ${this.formatCentimetres(selection.height)} cm`;
        const properties = {};
        properties[this.dataset.propSize] = `${selection.size} cm`;
        properties[this.dataset.propConfiguration] = selection.label;
        properties[this.dataset.propQuantity] = String(selection.quantity);
        properties[this.dataset.propFootprint] = footprint;
        properties[this.dataset.propSpacing] = `${selection.spacing} mm`;
        properties[this.dataset.propOverlap] = `${selection.overlap} mm`;

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(selection.variantId), quantity: selection.quantity, properties }]
            })
          });
          if (!response.ok) throw new Error('Cart request failed');
          this.addLabel.textContent = this.dataset.addedLabel;
          this.status.textContent = this.dataset.addedLabel;
          if (this.dataset.cartBehavior === 'redirect') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        } catch (error) {
          this.status.textContent = this.dataset.errorLabel;
          this.status.dataset.error = 'true';
        } finally {
          this.addButton.removeAttribute('aria-busy');
          if (this.dataset.cartBehavior !== 'redirect') this.update(false);
        }
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      }

      formatCentimetres(millimetres) {
        return Number((millimetres / 10).toFixed(1)).toLocaleString(document.documentElement.lang || 'en');
      }

      template(source, values) {
        return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), source);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
